import React from "react";
import { connect } from "react-redux";
import { fetchMenu } from "../store/actions";

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navOpen: false,
    };
  }

  componentDidMount() {
    this.props.fetchMenu();
  }

  handleClick() {
    this.setState({
      navOpen: !this.state.navOpen,
    });
  }

  renderBrand = () => {
    if (window.location.pathname === "/") {
      return (
        <a href="/">
          <img src="/images/logo.jpg" alt="logo" width="50" />
        </a>
      );
    } else {
      return (
        <a href="/">
          <img src="/images/logo.jpg" alt="logo" width="50" />
          <span className="text-uppercase text-blue font-weight-bold">
            Home
          </span>
        </a>
      );
    }
  };

  renderMenu = () => {
    const { menuState } = this.props;

    if (!menuState.settled) {
      return null;
    }

    return menuState.results.map((item) => (
      <a
        key={item.id}
        className={`menu-item ${String(item.data.color).toLowerCase()}`}
        href={item.data.link}
      >
        {item.data.name[0].text}
      </a>
    ));
  };

  render() {
    const navOpenClass = this.state.navOpen ? "active" : "";

    return (
      <nav className="navigation">
        <div className="container">
          <div className="brand">
            {this.renderBrand()}

            <div className="toggle" onClick={this.handleClick.bind(this)}>
              {this.state.navOpen ? (
                <i className="fas fa-times fa-lg" />
              ) : (
                <i className="fas fa-bars fa-lg" />
              )}
            </div>
          </div>
          <div className={`menu-list ${navOpenClass}`}>{this.renderMenu()}</div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  menuState: state.menu,
});

export default connect(mapStateToProps, {
  fetchMenu,
})(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation.js